// extracted by mini-css-extract-plugin
module.exports = {"mainfooter":"footer_mainfooter__honUN"};